import {ADMIN_API_BASE} from "./apiConfig";

export function resolveCourseImageUrl(key) {
    if (!key) return "";
    if (key.startsWith("blob:") || key.startsWith("data:")) return key;

    return `${ADMIN_API_BASE}/course/image-proxy?key=${encodeURIComponent(key)}`;
}
